import { render, staticRenderFns } from "./entityCollection.vue?vue&type=template&id=68b0b1fc&scoped=true"
import script from "./entityCollection.vue?vue&type=script&lang=js"
export * from "./entityCollection.vue?vue&type=script&lang=js"
import style0 from "./entityCollection.vue?vue&type=style&index=0&id=68b0b1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0b1fc",
  null
  
)

export default component.exports